import React from 'react';
import { ChevronDown } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

/**
 * Language Selector Component
 * 
 * Dropdown for language selection (EN, FR, DE, ES)
 * Can be used in navbar or header
 */
export const LanguageSelector = ({ variant = 'compact' }) => {
  const { language, setLanguage, languages } = useLanguage();
  const [isOpen, setIsOpen] = React.useState(false);

  if (variant === 'dropdown') {
    return (
      <div className="relative inline-block">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="flex items-center gap-2 px-3 py-2 rounded-lg border border-input bg-white/50 hover:bg-white/70 transition-colors font-medium text-sm text-foreground"
          title={`Language: ${languages[language].name}`}
        >
          <span className="font-semibold">{language.toUpperCase()}</span>
          <ChevronDown size={16} className="transition-transform" style={{transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)'}} />
        </button>

        {isOpen && (
          <div className="absolute right-0 mt-2 bg-white border border-input rounded-lg shadow-md z-50 min-w-[140px] py-1 overflow-hidden">
            {Object.entries(languages).map(([code, { name, flag }]) => (
              <button
                key={code}
                onClick={() => {
                  setLanguage(code);
                  setIsOpen(false);
                }}
                className={`w-full px-4 py-2 text-left text-sm font-medium transition-colors flex items-center gap-2 ${
                  language === code 
                    ? 'bg-primary text-white' 
                    : 'text-foreground hover:bg-muted'
                }`}
                title={name}
              >
                <span className="text-lg">{flag}</span>
                <span>{code.toUpperCase()}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    );
  }

  // Compact button variant
  return (
    <div className="flex gap-2">
      {Object.entries(languages).map(([code, { flag, name }]) => (
        <button
          key={code}
          onClick={() => setLanguage(code)}
          className={`px-3 py-2 rounded-lg font-medium transition-colors text-sm flex items-center gap-1 ${
            language === code
              ? 'bg-primary text-white shadow-sm'
              : 'border border-input bg-white/50 text-foreground hover:bg-white/70'
          }`}
          title={name}
        >
          <span className="text-lg">{flag}</span>
          <span className="hidden sm:inline">{code.toUpperCase()}</span>
        </button>
      ))}
    </div>
  );
};

export default LanguageSelector;
